export const initialState = {
  surveys: [],
  survey: {},
  filters: {},
  publishSurveys: []
};
